// extracted by mini-css-extract-plugin
export default {"insurance":"clinicInsurance_insurance__UTXgg"};